<template>
  <div>
    <app-banner title="Web Affiliate Tracking Code" />
    <section class="content-wrapper">
      <div class="content">
        <p class="p3" v-if="!textLink">
          To activate your Web Affiliate Badge, copy the block of code below and
          paste it into your website's source code.
          <a href="" @click.prevent="showModal = true"
            >(Need help with Wordpress?)</a
          >
          If you have technical questions please
          <a href="mailto:mark.bauer@pilates.com">contact us</a>.
        </p>
        <p class="p3" v-else>
          Your affiliate URL is below. Copy the code and paste it into your
          website's source code.
          <a href="https://www.youtube.com/watch?v=CA3b0a4u9sY" target="_blank"
            >(How do I do this?)</a
          >
          If you have technical questions please
          <a href="mailto:mark.bauer@pilates.com">contact us</a>.
        </p>
        <div class="code-box-wrapper">
          <div class="code-box">
            {{ code }}
          </div>
        </div>
        <div class="button-set">
          <button
            class="btn"
            v-clipboard:copy="code"
            v-clipboard:success="onCopy"
          >
            Copy Code to Your Clipboard
          </button>
          <button class="btn ghost" @click="nextPage">
            Start Over
          </button>
        </div>
        <p class="alert" v-if="copySucceeded">
          Code copied to your clipboard. Go forth and paste!
        </p>
        <a class="link" @click="prevPage" v-if="!textLink">‹ Back</a>
        <a class="link" @click="page3" v-else>‹ Back</a>
      </div>
      <img
        :src="`${$assets}img-affiliate-5@1x.jpg`"
        :srcset="`${$assets}img-affiliate-5@2x.jpg 2x`"
        alt="Woman working out on a Reformer"
        class="wide photo"
      />
    </section>
    <modal v-if="showModal" @close="showModal = false">
      <h3 slot="header">WordPress Tip</h3>
      <div slot="body">
        <p>
          If you're using a content management system such as WordPress, you'll
          need to temporarily switch from the block (visual) editor to the code
          editor.
        </p>
        <img
          src="@/assets/images/wp-screenshot@1x.jpg"
          srcset="@/assets/images/wp-screenshot@2x.jpg 2x"
          alt="Wordpress screen shot"
          style="margin-top: 20px;"
        />
      </div>
    </modal>
  </div>
</template>

<script>
import AppBanner from "@/components/AppBanner.vue";
import Modal from "@/components/Modal.vue";

export default {
  name: "StepFive",

  components: {
    AppBanner,
    Modal
  },

  props: {
    id: String,
    url: String,
    size: String,
    image: String,
    textLink: Boolean
  },

  data() {
    return {
      copySucceeded: "",
      showModal: false
    };
  },

  computed: {
    code() {
      const fullUrl = this.getFullUrl() + "?bbAffiliateID=" + this.id;
      if (!this.textLink) {
        const sizeArr = this.size.split("x");
        const width = sizeArr[0];
        const height = sizeArr[1];
        return `<a href="${fullUrl}"><img src="https://s3.amazonaws.com/s3.pilates.com/web-affiliates/affiliate-button-${this.size}_${this.image}@2x.jpg" width="${width}" height="${height}"></a>`;
      } else {
        return fullUrl;
      }
    }
  },

  methods: {
    getFullUrl() {
      if (!/^[a-z0-9]+:\/\//.test(this.url)) {
        let newUrl = "https://" + this.url;
        return newUrl;
      } else if (/^[a-z0-9]+:\/\//.test(this.url)) {
        let newUrl = this.url.replace(/^[a-z0-9]+:\/\//i, "");
        return "https://" + newUrl;
      } else {
        return this.url;
      }
    },

    onCopy() {
      this.copySucceeded = true;
    },

    nextPage() {
      this.$emit("clicked", "one");
    },

    prevPage() {
      this.$emit("clicked", "four");
    },

    page3() {
      this.$emit("clicked", "three");
    }
  }
};
</script>

<style scoped>
.content-wrapper {
  display: flex;
  justify-content: center;
}

.content {
  padding: 50px 32px;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
}

label {
  display: inline-block;
  font-family: sans-serif, Arial;
  font-size: 16px;
  border-radius: 0;
  transition: 0.3s;
  cursor: pointer;
  margin-right: 20px;
  margin-bottom: 20px;
  box-sizing: border-box;
}

input[type="radio"] {
  opacity: 0;
  position: fixed;
  width: 0;
}

input[type="radio"]:checked + label {
  border: 3px solid var(--green);
}

label:hover {
  background-color: var(--lt-gray);
}

.flex {
  display: flex wrap;
  margin: 30px 0;
  justify-content: center;
}

.one {
  background: var(--white)
    url("http://s3.amazonaws.com/s3.pilates.com/web-affiliates/bb-gray-mark.svg")
    no-repeat center/40%;
}

.two {
  background: var(--white)
    url("http://s3.amazonaws.com/s3.pilates.com/web-affiliates/bb-gray-mark.svg")
    no-repeat center/60%;
}

.three {
  background: var(--white)
    url("http://s3.amazonaws.com/s3.pilates.com/web-affiliates/bb-gray-mark.svg")
    no-repeat center/40%;
}

.button-set {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}

.btn {
  background-color: var(--green);
  color: var(--white);
  border: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 14rem;
  line-height: 1.143;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 225px;
  height: 30px;
  transition: 0.3s;
  margin-bottom: 10px;
  margin-right: 10px;
}

.btn:hover {
  background-color: var(--dk-green);
}

.ghost {
  background-color: var(--white);
  color: #5e5f61;
  border: 2px solid var(--green);
  width: 225px;
  height: 30px;
}

.ghost:hover {
  background-color: var(--lt-gray);
}

.link {
  font-family: var(--roboto);
  font-size: 14rem;
  line-height: 1.143;
  font-weight: 500;
  color: var(--emerald);
  text-decoration: none;
  margin-top: auto;
  cursor: pointer;
}

.link:hover {
  text-decoration: underline;
}

.photo {
  width: 41%;
  max-width: 472px;
  object-fit: cover;
  flex: 0 0 auto;
  margin-left: auto;
}

.badge-img {
  display: block;
  box-sizing: border-box;
}

.code-box-wrapper {
  width: 100%;
  border: 1px solid var(--green);
  background-color: var(--lt-gray);
  border-radius: 18px;
  margin: 35px 0;
  padding: 45px 35px;
}

.code-box {
  overflow-x: scroll;
}

.alert {
  margin-bottom: 20px;
  font-size: 12rem;
}

.p3 a {
  color: inherit;
  transition: 0.3s;
}

.p3 a:hover {
  color: gray;
}

@media (min-width: 768px) {
  .content {
    padding: 70px 10% 70px 5%;
    width: 59%;
  }

  .btn {
    margin-bottom: 20px;
  }

  .ghost {
    width: 117px;
  }
}
</style>
